/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

declare global {
  interface Window {
    _config: Record<string, any>;
  }
}

/**
 * 获取 window._config 中的值, 统一使用此函数处理
 */
// eslint-disable-next-line no-underscore-dangle
export const getConfig = (key: string) => window._config[key];

export const APP_URL = getConfig('APP_URL') || getConfig('app_url');
export const API_ROOT = getConfig('API_ROOT') || getConfig('app_api');
export const RRP_WECHAT_ROOT = getConfig('RRP_WECHAT_ROOT') || getConfig('rrp_wechat_api');
export const FILE_URL = getConfig('FILE_URL') || getConfig('file_url');
